module.exports = __webpack_public_path__ + "static/media/click.81287add.mp4";